// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".driverSection[data-v-236c34eb]{border-radius:0 40px 40px 40px}.userSection[data-v-236c34eb]{border-radius:40px 40px 0 40px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
